import * as React from "react";
import ExpandableSection from "@amzn/awsui-components-react/polaris/expandable-section";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import DatePicker from "@amzn/awsui-components-react/polaris/date-picker";
import Select, { SelectProps } from "@amzn/awsui-components-react/polaris/select";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import ColumnLayout from "@amzn/awsui-components-react/polaris/column-layout";

export interface VacationData {
  travelStartAt: string;
  travelEndAt: string;
  travelDestination: string;
}

export const EMPTY_VACATION: VacationData = {
  travelStartAt: "",
  travelEndAt: "",
  travelDestination: "",
};

const DESTINATION_OPTIONS: SelectProps.Option[] = [
  { label: "Domestic", value: "DOMESTIC" },
  { label: "International", value: "INTERNATIONAL" },
];

interface Props {
  data: VacationData;
  onChange: (updated: VacationData) => void;
}

class VacationFields extends React.Component<Props> {
  render() {
    const { data, onChange } = this.props;
    const selectedDestination = DESTINATION_OPTIONS.find((o) => o.value === data.travelDestination) || null;

    return (
      <ExpandableSection headerText="Vacation Details" defaultExpanded>
        <SpaceBetween size="m">
          <ColumnLayout columns={3}>
            <FormField label="Travel Start">
              <DatePicker
                value={data.travelStartAt}
                onChange={({ detail }) => onChange({ ...data, travelStartAt: detail.value })}
                placeholder="YYYY/MM/DD"
              />
            </FormField>
            <FormField label="Travel End">
              <DatePicker
                value={data.travelEndAt}
                onChange={({ detail }) => onChange({ ...data, travelEndAt: detail.value })}
                placeholder="YYYY/MM/DD"
              />
            </FormField>
            <FormField label="Travel Destination">
              <Select
                selectedOption={selectedDestination}
                onChange={({ detail }) => onChange({ ...data, travelDestination: detail.selectedOption.value || "" })}
                options={DESTINATION_OPTIONS}
                placeholder="Select destination..."
              />
            </FormField>
          </ColumnLayout>
        </SpaceBetween>
      </ExpandableSection>
    );
  }
}

export default VacationFields;
